import PageLoader from "./page_loader";
import BookData from "./book_data";
import PainterProxy from './painter/proxy';
import { PAGE_TAG } from "./page_loader/page_tag";
export default class AFileLoader extends PageLoader {
    type = "afileLoader";

    afileSize = {
        width: 960,
        height: 540
    }
    currentSeriesImage = "";
    currentSeriesIndex = 0;

    loadSVGTimer = null;

    totalFrame = null;

    afileVue = null;

    loadBlur = false;

    backgroundDocuments = [];

    /**
     * 開啟A檔後會前往的影格
     * @type {Number}
     * @memberof AFileLoader
     */
    targetFrame = 0;
    /**
     * 一系列圖片開始的影格
     * @type {Number}
     * @memberof AFileLoader
     */
    startFrame = 0;

    loadQueueIndex = 0;
    /**
     *
     * @type {Array<Number>}
     * @memberof AFileLoader
     */
    loadQueue = [];

    /**
     *
     * @type {Function}
     * @memberof AFileLoader
     */
    onFinishPreQueue = null;


    initNeedScript() {

    }
    setAFileSize(width, height) {
        this.afileSize.width = width;
        this.afileSize.height = height;
    }

    initPageContainers(canvas, animation_container, dom_overlay_container, preloaderDiv, pageSvg) {
        let page = {
            canvas: null,
            stage: null,
            exportRoot: null,
            anim_container: null,
            dom_overlay_container: null,
            comp: null
        };

        this.pageContainers.push(page);

        this.pageCanvas = canvas;
        this.pageCanvas.style.display = 'block';

        this.anim_container = animation_container;
        this.dom_overlay_container = dom_overlay_container;
        this.preloaderDiv = preloaderDiv;
        this.pageBackgrounds.push(pageSvg);

        if (typeof this.initFinishCallback == "function") {
            this.initFinishCallback();
        }
    }

    handleComplete(evt, comp) {
        //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
        // console.log("handle complete ", this.pageLib)
        var lib = comp.getLibrary();
        this.pageLib = lib;
        var ss = comp.getSpriteSheet();
        var queue = evt.target;
        var ssMetadata = lib.ssMetadata;
        let i = 0;
        for (i = 0; i < ssMetadata.length; i++) {
            ss[ssMetadata[i].name] = new this.createjs.SpriteSheet({ "images": [queue.getResult(ssMetadata[i].name)], "frames": ssMetadata[i].frames })
        }
        // preloaderDiv = document.getElementById("preload_div_");
        this.preloaderDiv.style.display = 'none';

        let pageName = this.nowPages[this.loadPageProgress].split('.js')[0];
        // this.pageContainers[this.loadPageProgress].canvas.style.display = 'block';
        this.pageContainers[this.loadPageProgress].exportRoot = new lib[pageName];
        this.pageContainers[this.loadPageProgress].exportRoot.tag = PAGE_TAG.AFILE;
        if (this.pageStage == null) {
            this.pageStage = new this.createjs.Stage(this.pageCanvas);
            this.pageStage.enableMouseOver();
            //window.stage = this.pageStage;
            this.createjs.Ticker.addEventListener("tick", this.antialiasingObjects.bind(this));
        }
        //this.pageContainers[this.loadPageProgress].stage = new lib.Stage(this.pageContainers[this.loadPageProgress].canvas);
        // this.pageContainers[this.loadPageProgress].stage.enableMouseOver();
        this.pageContainers[this.loadPageProgress].comp = comp;

        //Registers the "tick" event listener.
        this.fnStartAnimation = function () {
            this.pageStage.startFrame = this.startFrame;
            this.pageStage.addChild(this.pageContainers[this.loadPageProgress].exportRoot);
            this.pageContainers[this.loadPageProgress].exportRoot.x = this.loadPageProgress * lib.properties.width;

            this.pageContainers[this.loadPageProgress].exportRoot.gotoAndStop(this.targetFrame);


            console.log("root duration", this.pageContainers[this.loadPageProgress].exportRoot.getDuration());
            this.totalFrame = this.pageContainers[this.loadPageProgress].exportRoot.getDuration() || 1;
            this.setAFileFrameBackgrounds();
            // this.loadBackground(this.startFrame);
            this.createjs.Ticker.framerate = lib.properties.fps;
            this.createjs.Ticker.addEventListener("tick", this.pageStage);
        }

        //Code to support hidpi screens and responsive scaling.
        window.AdobeAn.makeResponsive = this.makeResponsive.bind(this);
        window.AdobeAn.makeResponsive(true, 'both', true, 1, this.pageStage, this.pageLib, [this.pageCanvas, this.preloaderDiv, this.anim_container, this.dom_overlay_container]);
        window.AdobeAn.compositionLoaded(lib.properties.id);
        this.fnStartAnimation();
    }

    setAfile(afile) {
        this.afileVue = afile;
    }

    setAFileFrameBackgrounds() {
        for (let i = 0; i < this.totalFrame; i++) {
            let newBackground = {
                finish: false,
                url: BookData.Instance.getAFilePath() + this.nowPages[0] + "_" + i + ".svg"
            }
            this.afileVue.totalFrameSrc.push(newBackground);
            this.loadQueue.push(i);
            console.log(`${JSON.stringify(this.loadQueue)}`);
        }

        this.loadBackground(this.targetFrame);

        // console.log("page svg:", queue)
        // const self = this;
        // Promise.allSettled(queue)
        //     .then(values => {
        //         let fulfilledResults = [];
        //         values.forEach(element => {
        //             if(element.status === "fulfilled") {
        //                 fulfilledResults.push(element.value);
        //             }
        //         })
        //         self.handleQueueFinish(fulfilledResults)
        //     })
    }

    async handleQueueFinish(result) {
        let parser = new DOMParser();
        for (let i = 0; i < result.length; i++) {
            //console.log(result[i])
            let svgTxt = await result[i].text();
            let doc = parser.parseFromString(svgTxt, "image/svg+xml");
            this.overrideImgResource(doc.getElementsByTagName('defs').item(0).getElementsByTagName('image'));

            this.modifyText(doc);

            // override defs
            const defs = doc.getElementsByTagName('defs').item(0).children;
            for (let j = 0; j < defs.length; j++) {
                this.overrideUse(defs.item(j), doc)
            }

            this.overrideTagsId(this.uniqueTags, doc);

            this.backgroundDocuments.push(doc.documentElement);
            this.afileVue.$refs.pageSvg[i].append(doc.documentElement);
        }
        this.afileVue.show = true;
        this.afileVue.showSeries = false;

        this.loadBackground(this.targetFrame);
    }

    /**
     *
     * 依照影格數改變底圖讀取的圖片
     * @param {number} frame 目標影格數
     * @memberof AFileLoader
     */
    loadBackground(frame) {
        if (this.afileVue.totalFrameSrc.length == 0) {
            return;
        }
        // if target background svg is ready for show, change background;
        // console.log(`target frame: ${frame}`);
        if (this.afileVue.totalFrameSrc[frame].finish) {
            this.changeBackgroundByFrame(frame);
        } else {
            this.loadQueueIndex = frame;

            if (!this.afileVue.show) {
                this.loadBackgroundAndGo(frame);
            } else {
                this.onFinishPreQueue = this.loadBackground.bind(this, frame);
            }
        }
    }
    /**
     * 
     * @param {Number} frame 
     */
    async loadBackgroundAndGo(frame) {
        while (this.loadQueue[0] != frame) {
            this.loadQueue.push(this.loadQueue.shift());
        }

        const loadBackgroundResponse = await this.loadBackgroundByFrame(frame);
        if (loadBackgroundResponse) {
            this.loadQueue.shift();
            this.loadBackground(frame);
        }
    }

    async loadBackgroundQueue(frame) {
        console.log("frame:", frame);
        while (this.loadQueue[0] != frame) {
            this.loadQueue.push(this.loadQueue.shift());
        }
        console.log(`load queue: ${JSON.stringify(this.loadQueue)}`)
        const loadBackgroundResponse = await this.loadBackgroundByFrame(frame);
        if (loadBackgroundResponse) {
            const finishQueue = this.loadQueue.shift();
            if (this.loadQueue.length > 0) {
                if (this.loadQueueIndex == finishQueue) {
                    this.loadQueueIndex = this.loadQueue[0];
                    if (typeof this.onFinishPreQueue == "function") {
                        this.onFinishPreQueue();
                        this.onFinishPreQueue = null;
                    }
                }
                console.log("next::", this.loadQueueIndex);
                this.loadBackgroundQueue(this.loadQueueIndex);
            }

        }
    }

    async loadBackgroundByFrame(frame) {
        const response = await fetch(this.afileVue.totalFrameSrc[frame].url);
        const svg = await response.text();
        await this.handleSvgLoadFinish(frame, svg);
        return true;
    }

    handleSvgLoadFinish(frame, svg) {
        let parser = new DOMParser();
        const doc = parser.parseFromString(svg, "image/svg+xml");
        this.overrideImgResource(doc.getElementsByTagName('defs').item(0).getElementsByTagName('image'));

        this.modifyText(doc);

        // override defs
        const defs = doc.getElementsByTagName('defs').item(0).children;
        for (let j = 0; j < defs.length; j++) {
            this.overrideUse(defs.item(j), doc)
        }

        this.overrideTagsId(this.uniqueTags, doc);

        doc.documentElement.setAttribute("width", "2560px");
        doc.documentElement.setAttribute("height", "1440px");

        this.backgroundDocuments.push(doc.documentElement);
        this.afileVue.$refs.pageSvg[frame].append(doc.documentElement);
        this.afileVue.totalFrameSrc[frame].finish = true;

        console.log(this.afileVue.totalFrameSrc)

        return true;
    }

    /**
     *
     *
     * @param {number} frame
     * @memberof AFileLoader
     */
    changeBackgroundByFrame(frame) {
        if (this.afileVue != null && frame != null) {
            this.afileVue.nowFrame = frame;
            // this.afileVue.$refs.pageSvg[this.afileVue.nowFrame].append(this.backgroundDocuments[this.afileVue.nowFrame]);
            PainterProxy.getInstance().clearAll();
            // first show afile window, and continue load other frame
            if (!this.afileVue.show) {
                this.afileVue.show = true;
                this.afileVue.showSeries = false;
                if (this.loadQueue.length > 0) {
                    this.loadQueueIndex = Math.min(...this.loadQueue);
                    this.loadBackgroundQueue(this.loadQueueIndex);
                }
            }
        }
    }

    /**
     *
     * 依照輸入的檔案改變底圖讀取的圖片
     * @param {string} fileName
     * @memberof AFileLoader
     */
    changeBackground(fileName) {
        // this.pageBackgrounds[0].style.visibility = 'hidden';
        // this.pageCanvas.style.display = 'none';
        // this.pageBackgrounds[0].data = fileName + ".svg";
        this.currentSeriesImage = fileName;
        this.currentSeriesIndex = 0;
        // this.pageBackgrounds[0].data = BookData.Instance.getAFilePath() + this.currentSeriesImage + "_" + this.currentSeriesIndex + ".svg";
        this.changeSvgBackground(BookData.Instance.getAFilePath() + this.currentSeriesImage + "_" + this.currentSeriesIndex + ".svg")
        PainterProxy.getInstance().clearAll();
        this.checkBackgroundLoaded();
    }
    /**
     *
     * 切換系列底圖
     * @param {boolean} next 下一張/上一張
     * @memberof AFileLoader
     */
    changeSeriesBackground(next) {
        // this.pageBackgrounds[0].style.visibility = 'hidden';
        // this.pageCanvas.style.display = 'none';

        if (next) {
            this.currentSeriesIndex++;
        } else {
            this.currentSeriesIndex--;
        }

        // this.pageBackgrounds[0].data = BookData.Instance.getAFilePath() + this.currentSeriesImage + "_" + this.currentSeriesIndex + ".svg";
        this.changeSvgBackground(BookData.Instance.getAFilePath() + this.currentSeriesImage + "_" + this.currentSeriesIndex + ".svg")
        PainterProxy.getInstance().clearAll();
        this.checkBackgroundLoaded();
    }

    /**
     *
     * 取的目前系列圖的索引
     * @readonly
     * @memberof AFileLoader
     */
    get getCurrentSeriesIndex() {
        return this.currentSeriesIndex;
    }

    /**
     * 檢查底圖讀取完成
     *
     * @memberof AFileLoader
     */
    checkBackgroundLoaded() {
        return;
        const self = this;
        let svgDoc = self.pageBackgrounds[0].getSVGDocument();
        if (svgDoc == null) {
            if (self.loadSVGTimer != null) {
                clearTimeout(self.loadSVGTimer);
            }

            self.loadSVGTimer = setTimeout(() => {
                self.checkBackgroundLoaded();
            }, 300);
        } else {
            this.pageCanvas.style.display = 'block';
            this.pageBackgrounds[0].style.visibility = 'visible';
        }
        console.log('svgDoc ', svgDoc)
    }

    async changeSvgBackground(src) {
        console.log(src);
        console.log(this.pageBackgrounds[0]);

        const self = this;

        let parser = new DOMParser();
        let response = await fetch(src);
        let content = await response.text();
        let doc = parser.parseFromString(content, "image/svg+xml");

        this.overrideImgResource(doc.getElementsByTagName('defs').item(0).getElementsByTagName('image'));

        this.modifyText(doc);


        // override defs
        const defs = doc.getElementsByTagName('defs').item(0).children;
        for (let j = 0; j < defs.length; j++) {
            this.overrideUse(defs.item(j), doc)
        }

        this.overrideTagsId(this.uniqueTags, doc);

        doc.documentElement.style.position = "absolute";
        doc.documentElement.style.top = "0px";
        doc.documentElement.style.left = "0px";
        // doc.documentElement.classList.add("anim-change-background");
        doc.documentElement.style.opacity = "0";

        this.pageBackgrounds[0].append(doc.documentElement);

        setTimeout(() => {
            if (self.pageBackgrounds[0].children.length > 1) {
                self.pageBackgrounds[0].children[1].style.top = "0px";
                self.pageBackgrounds[0].children[1].style.left = "0px";
                self.pageBackgrounds[0].children[1].style.opacity = "1";

                self.pageBackgrounds[0].removeChild(self.pageBackgrounds[0].firstChild)
            } else {
                self.afileVue.showSeries = true;
                self.pageBackgrounds[0].firstChild.style.top = "0px";
                self.pageBackgrounds[0].firstChild.style.left = "0px";
                self.pageBackgrounds[0].firstChild.style.opacity = "1";
            }
        }, 100);
    }
    /**
     * 
     * @param {HTMLElement} element 
     */
    dosomething(element) {
        console.log(element.children.length);
    }

    /**
     * 
     * @param {HTMLCollectionOf<SVGImageElement>} nodes 
     */
    overrideImgResource(nodes) {
        for (let i = 0; i < nodes.length; i++) {
            const newImgSrc = BookData.Instance.getAFilePath() + nodes.item(i).getAttribute("xlink:href");
            // imgs.item(0).setAttribute("xlink:href", newImgSrc)
            nodes.item(i).setAttribute("xlink:href", newImgSrc);
        }
    }

    triggerResize() {
        if (this.pageLib && this.pageStage) {
            this.resizeCanvas(true, 'both', true, 1, this.pageStage, this.pageLib, [this.pageCanvas, this.preloaderDiv, this.anim_container, this.dom_overlay_container])
        }
    }

    resizeCanvas(isResp, respDim, isScale, scaleType, stage, lib, domContainers) {
        var lastW, lastH, lastS = 1;
        var w = lib.properties.width, h = lib.properties.height;
        this.stageWidth = w;
        this.stageHeight = h;
        // var iw = window.innerWidth / 2, ih=window.innerHeight - 100;			
        var iw = this.afileSize.width, ih = this.afileSize.height;
        var pRatio = window.devicePixelRatio || 1, xRatio = iw / w, yRatio = ih / h, sRatio = 1;
        if (isResp) {
            if ((respDim == 'width' && lastW == iw) || (respDim == 'height' && lastH == ih)) {
                sRatio = lastS;
            }
            else if (!isScale) {
                if (iw < w || ih < h)
                    sRatio = Math.min(xRatio, yRatio);
            }
            else if (scaleType == 1) {
                // sRatio = Math.min(xRatio, yRatio);
                sRatio = yRatio;
            }
            else if (scaleType == 2) {
                sRatio = Math.max(xRatio, yRatio);
            }
        }
        domContainers[0].width = w * pRatio * xRatio;
        domContainers[0].height = h * pRatio * sRatio;
        domContainers.forEach(function (container) {
            container.style.width = w * xRatio + 'px';
            container.style.height = h * sRatio + 'px';

            // PainterProxy.getInstance().setCurrentPainterSize(w * xRatio, h * sRatio);
            PainterProxy.getInstance().updateViewportTransform();
        });
        stage.scaleX = pRatio * xRatio;
        stage.scaleY = pRatio * sRatio;
        lastW = iw; lastH = ih; lastS = sRatio;
        stage.tickOnUpdate = false;
        stage.update();
        stage.tickOnUpdate = true;

        if (typeof this.onStageResize == 'function') {
            this.onStageResize(stage.scaleX, stage.scaleY)
            // for(let i = 0; i < this.pageBackgrounds.length; i++)
            // this.pageBackgrounds[i].style.transform = `scale(${stage.scaleX})`;
        }
    }

    resizeCanvasWithNoPage(domContainers) {
        console.log("trigger resize with default")
        var lastW, lastH, lastS = 1;
        var w = 2560, h = 1440;
        var iw = this.afileSize.width, ih = this.afileSize.height;
        var pRatio = window.devicePixelRatio || 1, xRatio = iw / w, yRatio = ih / h, sRatio = 1;

        sRatio = Math.min(xRatio, yRatio);

        domContainers.forEach(function (container) {
            container.style.display = 'none';
        });

        if (typeof this.onStageResize == 'function') {
            this.onStageResize(pRatio * xRatio, pRatio * sRatio)
        }
    }

    fixManifestPath(manifest) {
        let manifestPath = JSON.parse(JSON.stringify(manifest));;
        let fixedPath = manifestPath.map(item => {
            item.crossOrigin = "Anonymous";
            if (item.src.indexOf("https://") == -1) {
                if (item.src.indexOf(".png") != -1) {
                    item.src = BookData.Instance.getAFilePath() + item.src;
                }
                if (item.src.indexOf(BookData.Instance.getBookPath()) == -1) {
                    item.src = BookData.Instance.getBookPath() + item.src;
                }

            }
            return item;
        })

        return fixedPath;
    }

    fixLoadPath(path) {
        return BookData.Instance.getAFilePath() + path + ".js";
    }

    onLoadPageError() {
        this.resizeCanvasWithNoPage([this.pageCanvas, this.preloaderDiv, this.anim_container, this.dom_overlay_container]);
    }
}